export default __webpack_public_path__ + "static/media/cup.0591b8af.svg";